module.exports = __webpack_public_path__ + "static/media/34-13.dd327439.mp3";